@if (isMobileiOS) {
<div class="w-12 center wrap-m p-b"
     ngSkipHydration>
    @if (!modelsFiltered.length) {
    <p class="p-t-10 p-b-6 fs-8 center">{{'There are no results matching your selection' | translate}}</p>
    } @else {
    <cdk-virtual-scroll-viewport [ngClass]="['listing-size-' + listingSize]"
                                 [style.--grid-columns]="listingSize"
                                 [style.--grid-column-gap.px]="2"
                                 [style.--grid-row-gap.px]="7"
                                 scrollWindow
                                 [columns]="listingSize"
                                 [height]="productHeight"
                                 [gtmTrackViewItemList]="gtmTrackViewItemList()"
                                 [gtmTrackViewItemListOff]="client.isCms"
                                 (scrolledIndexChange)="onScrolledIndexChange($event)"
                                 #virtualScrollRef>
        <!-- Show actual products -->
        <ng-container *cdkVirtualFor="let model of modelsFiltered; trackBy: trackByFn; templateCacheSize: 0">
            @let gridCalc = getGridCalculation(model.id);
            @let alignValue = model.data?.align_on_listing | optionLabel : 'align_on_listing';
            
            <div class="block"
             [class]="gridCalc?.cssClasses"
             [gridColumn]="gridCalc?.gridColumn"
             [gridColumnPushLeft]="alignValue === 'left' ? 1 : 0"
             [gridColumnPushRight]="alignValue === 'right' ? 1 : 0"
             [gridRowSpan]="gridCalc?.gridRowSpan">
            <div class="h-100"
                 [class]="'w-' + gridCalc?.gridWidth">
                 @if (!!model.isBanner) {
                    <product-banner class="w-12 h-100"
                                    [model]="model"
                                    [priority]="$index < listingSize * 2" />
                    } @else {
                    <product class="w-12 h-100"
                             [modelView]="modelView"
                             [model]="model"
                             [priority]="$index < listingSize * 2"
                             [searchTerm]="context === 'search' ? searchResult?.term : undefined"
                             [sendTracking]="true"
                             [category]="category"
                             [listing]="listing"
                             [listId]="listId"
                             [listName]="listName"
                             [listPosition]="$index"
                             [listingSize]="listingSize"
                             cy-listingProduct />
                    }
                </div>
            </div>
        </ng-container>
    </cdk-virtual-scroll-viewport>
    }
</div>
} @else {
<div class="w-12 center wrap-m p-b"
     (infiniteScroll)="listing?.increaseLimit()"
     [infinitScrollActive]="!!listing?.hasMore"
     cy-searchProductsListing
     cy-listingProductsGrid>
    <div [class.listing-size-2]="listingSize === 2"
         [class.listing-size-3]="listingSize === 3"
         [class.listing-size-4]="listingSize === 4"
         [grid]="listingSize"
         [gridColumnGap]="['2px','2px','4px','4px'][app.client.sizeId]"
         [gridRowGap]="7"
         [gtmTrackViewItemList]="gtmTrackViewItemList()"
         [gtmTrackViewItemListOff]="client.isCms">
        <!-- Show actual products -->
        @for (model of listing?.models; track model.id) {
        @let gridCalc = getGridCalculation(model.id);
        @let alignValue = model.data?.align_on_listing | optionLabel : 'align_on_listing';
        <div class="block"
             [class]="gridCalc?.cssClasses"
             [gridColumn]="gridCalc?.gridColumn"
             [gridColumnPushLeft]="alignValue === 'left' ? 1 : 0"
             [gridColumnPushRight]="alignValue === 'right' ? 1 : 0"
             [gridRowSpan]="gridCalc?.gridRowSpan">
            <div class="h-100"
                 [class]="'w-' + gridCalc?.gridWidth">
                @if (!!model.isBanner) {
                <product-banner class="w-12 h-100"
                                [model]="model"
                                [priority]="$index < listingSize * 2" />
                } @else {
                <product class="w-12 h-100"
                         [modelView]="modelView"
                         [model]="model"
                         [priority]="$index < listingSize * 2"
                         [searchTerm]="context === 'search' ? searchResult?.term : undefined"
                         [sendTracking]="true"
                         [category]="category"
                         [listing]="listing"
                         [listId]="listId"
                         [listName]="listName"
                         [listPosition]="$index"
                         [listingSize]="listingSize"
                         cy-listingProduct />
                }
            </div>
        </div>
        } @empty {
        @for (item of skeletonArray(); track $index) {
        <div class="block">
            <skeleton-product />
        </div>
        } @empty {
        <p class="p-t-10 p-b-6 fs-8 center"
           [gridColumn]="listingSize">{{'There are no results matching your selection' | translate}}</p>
        }
        }
    </div>
</div>
}

<!-- back to top button -->
<back-to-top top="300" />